import Admin from "../Admin";
import React from "react";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import MUISaveButton from "@mui/icons-material/Save";
import MUILoadingButton from "@mui/lab/LoadingButton";
import Menu from "../../../Component/Menu";
import DialogConfirm from "../../../Component/Dialog/DialogConfirm";
import MUIMenuItem from "@mui/material/MenuItem";
import MUIListItemIcon from "@mui/material/ListItemIcon";
import CardAdminUserProductionTypeGeneral from "../../../Component/Card/Admin/UserProductionType/CardAdminUserProductionTypeGeneral";
import CardAdminUserProductionTypeTeam from "../../../Component/Card/Admin/UserProductionType/CardAdminUserProductionTypeTeam";
import Validator from "../../../Utility/Validator";
import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";
import UserProductionTypeService from "../../../Seating/Security/UserProductionTypeService/userProductionTypeService";

export default class AdminUserProductionTypeCreateEdit extends Admin {
  constructor(props) {
    super(props);

    this.state.isUpdate = !!props.match.params.id;
    this.state.userProductionType = {};
    this.state.isProcessing = false;
    this.state.confirmDialogOpen = false;
    this.state.validationIssues = {};
  }

  /**
   * Set the userProductionType in state.
   */
  afterComponentDidMount() {
    const userProductionTypeId = this.props.match.params.id
      ? +this.props.match.params.id
      : null;
    if (userProductionTypeId !== null) {
      this.setState({
        userProductionType:
          this.context.userProductionTypesIndexed[userProductionTypeId],
      });
    }
  }

  /**
   * Creates the userProductionType Link with the current properties in state.userProductionType.
   */
  async createUserProductionType() {
    this.setState({
      isProcessing: true,
    });

    return UserProductionTypeService.createUserProductionType(
      this.state.userProductionType,
    )
      .then((userProductionType) => {
        this.context.updateIndexed(
          "userProductionTypesIndexed",
          userProductionType,
        );
      })
      .then(() => {
        this.props.history.goBack();
        NotistackEnqueueSnackbar("User Production Type created successfully!", {
          variant: "success",
        });
      })
      .catch((err) => {
        console.log(err);
        NotistackEnqueueSnackbar(
          "Oh no! There was an error creating a new User Production Type",
          { variant: "error" },
        );
        this.setState({
          isProcessing: false,
        });
      });
  }

  /**
   * Updates the User Production Type with the current properties in state.salesPcrLink.
   */
  async updateUserProductionType() {
    this.setState({
      isProcessing: true,
    });

    return UserProductionTypeService.updateUserProductionType(
      this.state.userProductionType,
    )
      .then((userProductionType) => {
        this.context.updateIndexed(
          "userProductionTypesIndexed",
          userProductionType,
        );
        this.props.history.goBack();
        NotistackEnqueueSnackbar("User Production Type updated successfully!", {
          variant: "success",
        });
      })
      .catch((err) => {
        console.log(err);
        NotistackEnqueueSnackbar(
          "Oh no! There was an error updating the User Production Type.",
          { variant: "error" },
        );
        this.setState({
          isProcessing: false,
        });
      });
  }

  /**
   * Delete the User Production Type.
   */
  async deleteUserProductionType() {
    this.setState({
      isProcessing: true,
    });

    return UserProductionTypeService.deleteUserProductionType(
      this.state.userProductionType.id,
    )
      .then(() => {
        this.context.deleteIndexed(
          "userProductionTypesIndexed",
          this.state.userProductionType.id,
        );
        this.props.history.goBack();
        NotistackEnqueueSnackbar("User Production Type deleted successfully!", {
          variant: "success",
        });
      })
      .catch((err) => {
        console.log(err);
        NotistackEnqueueSnackbar(
          "Oh no! There was an error deleting the User Production Type",
          { variant: "error" },
        );
        this.setState({
          confirmDialogOpen: false,
        });
      });
  }

  /**
   * Render the content.
   */
  renderContent() {
    const handleChangeUserProductionType = (userProductionType) => {
      this.setState({
        userProductionType: {
          ...this.state.userProductionType,
          ...userProductionType,
        },
      });
    };

    return (
      <>
        <CardAdminUserProductionTypeGeneral
          userProductionType={this.state.userProductionType}
          onChange={handleChangeUserProductionType}
          validationIssues={this.state.validationIssues}
        />
        <CardAdminUserProductionTypeTeam
          userProductionType={this.state.userProductionType}
          onChange={handleChangeUserProductionType}
          validationIssues={this.state.validationIssues}
        />
        <DialogConfirm
          open={this.state.confirmDialogOpen}
          onClose={() => this.setState({ confirmDialogOpen: false })}
          onConfirm={() => this.deleteUserProductionType()}
          text="Are you sure you want to delete this User Production Type? This cannot be undone."
          header="Delete User Production Type"
          loading={this.state.isProcessing}
        />
      </>
    );
  }

  /**
   * @returns Page header
   */
  renderHeader() {
    let title;
    let subtitle;
    const buttonText = this.state.isUpdate ? "Save" : "Create";

    if (!this.state.isUpdate) {
      title = "Create User Production Type";
      subtitle = null;
    } else {
      title = "Edit User Production Type";
      subtitle = null;
    }

    const handleClickBack = () => {
      this.props.history.goBack();
    };

    const handleSave = () => {
      const validationIssues = Validator.validate(
        this.state.userProductionType,
        {
          name: {
            required: true,
          },
          teamId: {
            required: true,
          },
        },
      );

      this.setState({
        validationIssues: validationIssues,
      });

      if (Object.keys(validationIssues).length === 0) {
        if (this.state.isUpdate) {
          this.updateUserProductionType();
        } else {
          this.createUserProductionType();
        }
      } else {
        NotistackEnqueueSnackbar("Please correct the displayed issues.", {
          variant: "error",
        });
      }
    };

    const handleDelete = () => {
      this.setState({
        confirmDialogOpen: true,
      });
    };

    const buttons = [
      <MUIButton onClick={handleClickBack}>Back</MUIButton>,
      <MUILoadingButton
        loading={this.state.isProcessing}
        loadingPosition="start"
        onClick={handleSave}
        variant="contained"
        startIcon={<MUISaveButton />}
      >
        {buttonText}
      </MUILoadingButton>,
    ];

    if (this.state.isUpdate) {
      const menuItems = [
        <MUIMenuItem onClick={handleDelete}>
          <MUIListItemIcon>
            <MUIDeleteIcon fontSize="small" />
          </MUIListItemIcon>
          Delete
        </MUIMenuItem>,
      ];
      buttons.push(<Menu menuItems={menuItems} />);
    }

    return <PageHeader title={title} subtitle={subtitle} buttons={buttons} />;
  }
}
